import React from "react";
// import "./CanadaMasterfile.css";
import "../../GlobalCss/SPF/CanadaMasterfile.css";
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import {
  DeleteOutlined,
  UploadOutlined,
  SearchOutlined,
  LoadingOutlined,
  PlusOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Layout,
  Modal,
  message,
  Spin,
  Image,
  Upload,
  Grid,
  Input,
  Select,
  DatePicker,
} from "antd";
import {
  BaseUrl,
  JsonConfig,
  FormConfig,
  UserName,
} from "../../Repository/BaseRepository";
import CanadaMfTable from "../../Components/CanadaPayroll/CanadaMfTable";
import axios from "axios";
import { ErrorMessage, SuccessMessage ,InfoMessage, routes} from "../../Utils/Utils";
import { Redirect, Link } from "react-router-dom";
import { getCanadaMasterfileData, getUnmatchedListData } from "../../Repository/CanadaPayrollRepository";
import CanadaMasterfileTable from "../../Components/CanadaPayroll/CanadaMasterfileTable";
import {
  updateCanadaMFRow,
  getCanadaPayrollData,
  downloadCanadaMasterfileXL,
  getCanadaPayrollMasterfileData
} from "../../Repository/CanadaPayrollRepository";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import Cookies from "js-cookie";
const { Header, Content } = Layout;

const ConsolidatedData = () => {
  const [hrSourceFile, setHrSourceFile] = useState([]);
  const [unmdList, setUnmdList] = useState([]);
  const [spin, setSpin] = useState(false);
  const [unmdspin, seUnmdtSpin] = useState(false);
  const [hrUploader, setHrUploader] = useState("");
  const [unmdUploader, setUnmdUploader] = useState("");
  const [tableLoader, setTableLoader] = useState(false);
  const [griddata, setGriddata] = useState([]);
  const [unmatchedData, setUnmatchedData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [searchRow, setSearchRow] = useState("");
  const [csvLoader, setCsvLoader] = useState(false);
  const [masterfileLoading, setMasterfileLoading] = useState(false);
  const [unmatchedDataLoading, setUnmatchedDataLoading] = useState(false);
  const tenantName = Cookies.get("tenant_name");
  const [fromDate, setFromDate] = useState();
  const [toDate, setTodate] = useState();
  const [newFrom, setNewFrom] = useState("");
  const [newTo, setNewTo] = useState("");
  useEffect(() => {
    callAccoutsCube();
  }, []);
  const downloadMSfile = async (value) => {
    try {
      // setCsvLoader(true)
      if (value === "one") setMasterfileLoading(true);
      if (value === "two") setUnmatchedDataLoading(true);
      const resp = await downloadCanadaMasterfileXL(
        griddata,
        unmatchedData,
        value
      );
      if (resp === "downloaded") {
        SuccessMessage("Downloaded successfully !!");
      }
      // setCsvLoader(false)
      if (value === "one") setMasterfileLoading(false);
      if (value === "two") setUnmatchedDataLoading(false);
    } catch {
      ErrorMessage("Cannot able to download, please try again");
      // setCsvLoader(false)
      if (value === "one") setMasterfileLoading(false);
      if (value === "two") setUnmatchedDataLoading(false);
    }
  };
  const downloadUnmatchedDataExcel = async () => {
    try {
        setUnmatchedDataLoading(true); // Show loading state

        // Call the API to get unmatched list data
        const sanitizeCellValue = (value) => {
            if (typeof value === "string" && /^[=+\-@]/.test(value)) {
                return `'${value}`;
            }
            return value;
        };

        const sortSampleList = (list, fields) => {
            return list.sort((a, b) => {
                for (let field of fields) {
                    const valA = a[field]?.toString().toLowerCase() || "";
                    const valB = b[field]?.toString().toLowerCase() || "";
                    if (valA < valB) return -1;
                    if (valA > valB) return 1;
                }
                return 0;
            });
        };

        const unmatchedData = await getUnmatchedListData();

        // Handle case when payload is empty or status code is 204
        if (!unmatchedData || unmatchedData.length === 0) {
            InfoMessage("There is no Unmatched List");
            return null;
        }

        let sampleList = sortSampleList(unmatchedData, ["Client"]);
        let loopedList = [];

        loopedList.push(['Client', 'PayrollName', 'PositionID'].map(sanitizeCellValue));

        sampleList.forEach(item => {
            loopedList.push([
                sanitizeCellValue(item.Client),
                sanitizeCellValue(item.Payrollname),
                sanitizeCellValue(item.PositionID),
            ]);
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
        loopedList.forEach(row => worksheet.addRow(row));

        await workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'unmatched.xlsx');
        });
        SuccessMessage("File downloaded successfully.");
        return "downloaded";

    } catch (error) {
        console.error("Error downloading unmatched data:", error);
        ErrorMessage("Failed to download unmatched data. Please try again.");
    } finally {
        setUnmatchedDataLoading(false); // Hide loading state
    }
};

  const callAccoutsCube = async () => {
    try {
      setTableLoader(true);
      const res = await getCanadaMasterfileData();
      if (res !== null && res.length > 0) {
        if (res[0] !== null && res[0] !== null) {
          setGriddata(res[0]);
          setUnmatchedData(res[1]);
        }
        if (res[1] !== null && res[1] !== null) {
          setUnmatchedData(res[1]);
        }
      }
      setTableLoader(false);
    } catch {
      ErrorMessage("Cannot able to get data, please try again");
    }
  };
  const handleUpload = async (options) => {
    try {
      setSpin(true);
      const { file, onSuccess, onError } = options;
      const updatedDeductionFile = { file, status: "uploading" };
      const formData = new FormData();
      formData.append("ACFIle", file);
      setHrSourceFile([]);
      setHrUploader(file.name);
      const response = await axios.post(
        `${BaseUrl}CanadaPayrollMasterfile/UploadActiveListFile`,
        formData,
        FormConfig
      );
      if (response.data.statusCode === 200) {
        // callAccoutsCube();
        onSuccess(file);
        message.success(`File uploaded successfully`);
        updatedDeductionFile.status = "done";
        setHrSourceFile([updatedDeductionFile]);
        setHrUploader("");
        setSpin(false);
      } else if (response.data.statusCode === 400) {
        onError(file);
        message.error(response.data.message);
        updatedDeductionFile.status = "error";
        setHrSourceFile([updatedDeductionFile]);
        setHrUploader("");
        setSpin(false);
      } else {
        onError(file);
        message.error(response.data.message);
        updatedDeductionFile.status = "error";
        setHrSourceFile([updatedDeductionFile]);
        setHrUploader("");
        setSpin(false);
      }
    } catch (error) {
      message.error(`File upload failed`);
      setHrUploader("");
      setSpin(false);
    }
  };
  const itemRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (hrSourceFile.length > 0) {
      fileExists = true;
    }
    return (
      <>
        <div
          style={{
            display: "flex",
            height: "auto",
            height: "auto",
            width: 400,
            wordWrap: "break-word",
            marginTop: "15px",
          }}
        >
          <div
            style={{
              color: statusColor,
              height: "auto",
              display: "flex",
              wordWrap: "break-word",
              borderRadius: "4px",
            }}
          >
            {fileExists ? (
              <div
                style={{
                  height: "auto",
                  width: "fit-content",
                  wordBreak: "break-all",
                }}
              >
                {hrSourceFile[0].file.name}{" "}
              </div>
            ) : null}
          </div>
          <DeleteOutlined
            style={{ marginLeft: 5 }}
            onClick={() => setHrSourceFile([])}
          />
        </div>
      </>
    );
  };
  const handleUnmatchedUpload = async (options) => {
    try {
      seUnmdtSpin(true);
      const { file, onSuccess, onError } = options;
      const updatedDeductionFile = { file, status: "uploading" };
      const formData = new FormData();
      formData.append("unMatchedFile", file);
      setUnmdList([]);
      setUnmdUploader(file.name);
      const response = await axios.post(
        `${BaseUrl}CanadaPayrollMasterfile/UploadUnMatchedData`,
        formData,
        FormConfig
      );
      if (response.data.statusCode === 200) {
        // callAccoutsCube();
        onSuccess(file);
        message.success(`File uploaded successfully`);
        updatedDeductionFile.status = "done";
        setUnmdList([updatedDeductionFile]);
        setUnmdUploader("");
        seUnmdtSpin(false);
      } else if (response.data.statusCode === 400) {
        onError(file);
        message.error(response.data.message);
        updatedDeductionFile.status = "error";
        setUnmdList([updatedDeductionFile]);
        setUnmdUploader("");
        seUnmdtSpin(false);
      } else {
        onError(file);
        message.error(response.data.message);
        updatedDeductionFile.status = "error";
        setUnmdList([updatedDeductionFile]);
        setUnmdUploader("");
        seUnmdtSpin(false);
      }
    } catch (error) {
      message.error(`File upload failed`);
      setUnmdUploader("");
      seUnmdtSpin(false);
    }
  };
  const itemRenderUnmatched = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (unmdList.length > 0) {
      fileExists = true;
    }
    return (
      <>
        <div
          style={{
            display: "flex",
            height: "auto",
            height: "auto",
            width: 400,
            wordWrap: "break-word",
            marginTop: "15px",
          }}
        >
          <div
            style={{
              color: statusColor,
              height: "auto",
              display: "flex",
              wordWrap: "break-word",
              borderRadius: "4px",
            }}
          >
            {fileExists ? (
              <div
                style={{
                  height: "auto",
                  width: "fit-content",
                  wordBreak: "break-all",
                }}
              >
                {unmdList[0].file.name}{" "}
              </div>
            ) : null}
          </div>
          <DeleteOutlined
            style={{ marginLeft: 5 }}
            onClick={() => setUnmdList([])}
          />
        </div>
      </>
    );
  };
  const changeFromDate = (e) => {
    let sample = new Date(e);
    if (e !== null) {
      setFromDate(sample);
    } else {
      setFromDate();
    }
    var newD =
      parseInt(sample.getMonth() + 1) +
      "/" +
      parseInt(sample.getDate()) +
      "/" +
      parseInt(sample.getFullYear());
    setNewFrom(newD);
    if (toDate !== undefined && sample < toDate && e !== null) {
  
      callConsolidatedApi(newD, newTo);
    } else if (toDate !== undefined && sample > toDate && e !== null) {
      InfoMessage("From date should not be greater than To date");
    }
  };
  const changeToDate = (e) => {
    let sample = new Date(e);
    if (e !== null) {
      setTodate(sample);
    } else {
      setTodate();
    }
    var newD =
      parseInt(sample.getMonth() + 1) +
      "/" +
      parseInt(sample.getDate()) +
      "/" +
      parseInt(sample.getFullYear());
    setNewTo(newD);
    if (fromDate !== undefined && fromDate < sample && e !== null) {
     
      callConsolidatedApi(newFrom, newD);
    } else if (fromDate !== undefined && fromDate > sample && e !== null) {
      InfoMessage("To date should be greater than From date");
    }
  };
  const callConsolidatedApi = async (from, to) => {
    try {
      setTableLoader(true);
      const res = await getCanadaPayrollMasterfileData(from, to);
      console.log(res);
      if (res && res.MasterData && res.MasterData.length > 0) {
        setGriddata(res.MasterData);}
      setTableLoader(false);
    } catch {
      ErrorMessage("Cannot able to get data, please try again");
    }
  };
  return (
    <>
      <Layout
        style={{
          backgroundColor: "white",
          height: "100vh",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <SideNavBar />
        <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
          <Header className="preview-header-class">
            <Navbar />
          </Header>
          <Content style={{ overflow: "auto", height: "100%", marginLeft: 20 }}>
            <h1 className="canada-header">Canada Payroll</h1>
            <div className="otherpage-buttons">
              <Link to={`/${tenantName}/canadaautocrawl`}>
                <Button className="page-button">AutoCrawl</Button>
              </Link>
              <Link to={`/${tenantName}/canadapayroll`}>
                <Button className="page-button">Selected Crawling</Button>
              </Link>
              <Link to={`/${tenantName}/consolidateddata`}>
                <Button className="page-button">Consolidated Data</Button>
              </Link>
              <Button className="currentpage-button">Masterfile</Button>
            </div>
            <div className="ten99-row1">
              <div
                className="inputfile-upload"
                style={{ marginRight: "10px" }}
              >
                <Upload
                  className="hr-upload-file"
                  name="file"
                  customRequest={handleUpload}
                  itemRender={itemRender}
                  fileList={hrSourceFile}
                  accept=".xls,.xlsx"
                  onRemove={() => setHrSourceFile([])}
                  style={{
                    border: "1px solid #3B52DF",
                    borderRadius: 10,
                    borderStyle: "dashed",
                  }}
                >
                  <div className="hr-content-file">
                    <span className="hrfile-name">Upload Active List</span>
                    {spin ? (
                      <Spin
                        indicator={
                          <LoadingOutlined
                            className="upload-spinner"
                            style={{
                              fontSize: 16,
                              // marginLeft: 7,
                              color: "#3B52DF",
                            }}
                            spin
                          />
                        }
                      />
                    ) : (
                     
                      <Image
                        src="/Images/uploadimg (2).png"
                        style={{
                          border: "none",
                          width: 19,
                          height: 17,
                        }}
                        showPreviewIcon={false}
                        preview={false}
                      />
                    )}
                  </div>
                </Upload>
                {hrUploader.length > 0 ? (
                  <div
                    style={{
                      width: "fit-content",
                      wordBreak: "break-all",
                      marginBottom: 2,
                      color: "#3B52DF",
                    }}
                  >
                    {hrUploader}
                  </div>
                ) : null}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingRight: 10,
                }}
              >
                <Button
                  type="default"
                  loading={unmatchedDataLoading}
                  onClick={downloadUnmatchedDataExcel}
                  style={{
                    color: "#3b52df",
                    borderColor: "#3b52df",
                    height: "38px",
                    marginTop: "-35px",
                 
                  }}
                >
                  Download Unmatched Data <DownloadOutlined />
                </Button>
              </div>
              <div
                className="unmatchedfile-upload"
                style={{ marginLeft: "10px" }}
              >
                <Upload
                  className="unmd-upload-file"
                  name="file"
                  customRequest={handleUnmatchedUpload}
                  itemRender={itemRenderUnmatched}
                  fileList={unmdList}
                  accept=".xls,.xlsx"
                  onRemove={() => setUnmdList([])}
                  style={{
                    border: "1px solid #3B52DF",
                    borderRadius: 10,
                    borderStyle: "dashed",
                   
                  }}
                >
                  <div className="unmd-content-file">
                    <span className="hrfile-name">Upload Unmatched Data</span>
                    {unmdspin ? (
                      <Spin
                        indicator={
                          <LoadingOutlined
                            className="upload-spinner"
                            style={{
                              fontSize: 16,
                              marginLeft: 7,
                              color: "#3B52DF",
                            }}
                            unmdspin
                          />
                        }
                      />
                    ) : (
                      // <Spin size="medium" style={{ marginLeft: '5px', marginTop:"3px" }} />
                      <Image
                        src="/Images/uploadimg (2).png"
                        style={{
                          border: "none",
                          width: 19,
                          height: 17,
                        }}
                        showPreviewIcon={false}
                        preview={false}
                      />
                    )}
                  </div>
                </Upload>
                {unmdUploader.length > 0 ? (
                  <div
                    style={{
                      width: "fit-content",
                      wordBreak: "break-all",
                      marginBottom: 2,
                      color: "#3B52DF",
                    }}
                  >
                    {unmdUploader}
                  </div>
                ) : null}
              </div>
              <div >
            <DatePicker
              className="msf-datepickers"
              onChange={changeFromDate}
              placeholder="From Date"
              format={"MM-DD-YYYY"}
            />
            <DatePicker
              className="msf-datepickers"
              onChange={changeToDate}
              placeholder="To Date"
              format={"MM-DD-YYYY"}
            />
           
          </div>
              <Button
                type="default"
                loading={masterfileLoading}
                className="row-button"
                onClick={() => downloadMSfile("one")}
                style={{
                  backgroundColor: "#3b52df",
                  borderColor: "#3b52df",
                  height: "38px",
                  marginLeft:"20px",
                  marginTop: "-35px",
                 
                }}
              >
                Download Masterfile <DownloadOutlined />
              </Button>
              {/* <Button className="add-row-1099" onClick={() => AddNewRecord()}>Add New Record<PlusOutlined /></Button> */}
            </div>

            <div className="canada-row3">
              <CanadaMasterfileTable
                tableLoader={tableLoader}
                setTableLoader={setTableLoader}
                griddata={griddata}
                setGriddata={setGriddata}
                unmatchedData={unmatchedData}
              />
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
export default ConsolidatedData;
